import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/everyone_500.png'


const _withScopeId = n => (_pushScopeId("data-v-915942c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { computed } from 'vue';
import { PrincipalType } from '@/gp/GroupAdminModel'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { LoadMode } from '@/util/AsyncData'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { StatusInfo } from '@/util/AppUtil'
import CompactItem from '@/util/CompactItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupItem',
  props: {
    familyGroupId: {},
    userId: {},
    selectMode: { type: Boolean },
    status: {},
    raised: { type: Boolean }
  },
  emits: [
  'click',
],
  setup(__props: any, { emit }) {

const props = __props;





const familyGroupStore = useFamilyGroupStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const userStore = useUserStore()

const memberStatusText = {
  noprofile: 'No profile',
  profileonly: 'Profile only',
  owner: 'Owner',
  member: undefined,
}
const memberStatusStyle = {
  noprofile: 'secondary',
  profileonly: 'secondary',
  owner: 'warning',
  member: undefined,
}

const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(props.familyGroupId)?.data)
const ownerRef = computed(() => userStore.getAsyncUser(familyGroupRef.value?.ownerId)?.data)
const userRef = computed(() => userStore.getLoadedUserList([props.userId], LoadMode.EnsureLoaded).at(0))
const userMemberRef = computed(() => familyGroupMemberStore.getMembersForUsers([props.userId], LoadMode.EnsureLoaded)
  .find(fm => fm.familyGroupId == props.familyGroupId))
const profileMemberRef = computed(() => dataGroupMemberStore.getMembersForDataGroups([userRef.value?.profileDataGroupId], LoadMode.EnsureLoaded)
  .find(dm => dm.principalType == PrincipalType.FamilyGroup && dm.principalId == props.familyGroupId))

const showStatusRef = computed(() => props.userId || props.status)

const memberStatusRef = computed(() => 
  ownerRef.value?.id == props.userId ? 'owner' :
  !profileMemberRef.value ? 'noprofile' :
  !userMemberRef.value ? 'profileonly' :
  'member')

const statusTextRef = computed(() => props.status?.text ?? memberStatusText[memberStatusRef.value])
const statusStyleRef = computed(() => props.status?.style ?? memberStatusStyle[memberStatusRef.value])


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CompactItem, {
    class: "family-group-item",
    "select-mode": _ctx.selectMode,
    pageUrl: familyGroupRef.value?.pageUrl,
    "status-style": statusStyleRef.value,
    shadow: "",
    raised: _ctx.raised,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, _createSlots({
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(familyGroupRef.value?.name), 1)
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode(" Group managed by " + _toDisplayString(ownerRef.value?.displayName), 1)
    ]),
    _: 2
  }, [
    (showStatusRef.value)
      ? {
          name: "statusText",
          fn: _withCtx(() => [
            _createTextVNode(_toDisplayString(statusTextRef.value), 1)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["select-mode", "pageUrl", "status-style", "raised"]))
}
}

})